import { ModalBody, TeaserModal } from '@george-labs.com/design-system';
import type { FC } from 'react';

import { sanitize } from '@luna/utils';
import type { Severity } from '@api-client/temporary-messages';

import { TeaserModalIllustration } from './TeaserModalIllustration';
import { getTemporaryMessageModalColor } from './TemporaryMessageModalService';

interface Props {
    isOpen: boolean;
    title: string;
    text: string;
    onClose(): void;
    severity: Severity;
}

export const TemporaryMessageModal: FC<Props> = ({ isOpen, title, text, onClose, severity }) => {
    return (
        <TeaserModal
            illustration={<TeaserModalIllustration severity={severity} />}
            title={title}
            isOpen={isOpen}
            onClose={onClose}
            footerClassName="d-none"
            color={getTemporaryMessageModalColor(severity)}
            inverted={false}
            headerClassName="py-4"
        >
            <ModalBody data-cy="temporary-message-detail">
                <div
                    dangerouslySetInnerHTML={{
                        __html: sanitize(text),
                    }}
                />
            </ModalBody>
        </TeaserModal>
    );
};
